export default {
	mounted() {
		this.onRouteChange();
	},
	watch: {
		$route: function() {
			this.onRouteChange();
		},
	},
};
